var e=e=>e?.size==0;export{e as default};